/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: bbqin
 * @LastEditTime: 2023-06-07 15:49:03
 * @Description: file content
 */
import React, { Component, Fragment } from 'react';
import { Tooltip } from '@platform/base';
import { firstToUpperCase } from './util';
import { microAppUtil } from '@platform/api';
import './create.less';
function getTooltipMsg(msg) {
    if (typeof msg === 'string' && msg.indexOf('\\n') > -1) {
        msg = msg.replaceAll('\\n', '\n');
    }
    return msg;
}
export default class HelperTip extends Component {
    constructor(props) {
        super(props);
        this.currenbody = microAppUtil.getDocument();
    }
    render() {
        let { keyboard, title, btntip, showTooltip, children, disabled, delayShow } = this.props;
        // let processedKeyboard = keyboard && keyboard.replace(/(\+|,|，|\s)/g, '_');
        let overlay = [];
        overlay.push(<div className='button-help-tooltip'>{(title || '') + (keyboard ? `  (${firstToUpperCase(keyboard)})` : '')}</div>);
        if (btntip) {
            overlay.push(<div className='button-help-tooltip-des'>{getTooltipMsg(btntip)}</div>);
        }
        let tip = <Fragment>{overlay}</Fragment>;
        return (keyboard || btntip || showTooltip) && disabled !== true ? (
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            <Tooltip
                key='ss'
                placement="bottom"
                inverse
                overlay={tip}
                trigger={['hover']} // 去除  , "focus"
                className='btn-helper-overlay'
                onMouseOver={e => {
                    if (e.target.className && e.target.className.includes('base-loading')) {
                        e.stopPropagation();
                        // 单词写错啦
                        e.preventDefault();
                    }
                }}
                onMouseOut={() => {
                    let dom = this.currenbody.querySelector('.btn-helper-overlay');
                    if (dom) {
                        dom.style.display = 'none';
                    }
                }}
                delayShow={delayShow}
            >
                {children}
            </Tooltip>
        ) : (
            children
        );
    }
}
